<app-result *ngIf="company?.bondRequest" [currBondRequest]="company.bondRequest" [error]="error" (goToEdit)="goToRequest()"></app-result>
